/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */

import { recursivelyEnhanceMedia } from "@/util/mediaHelper.js";

function storeVarPayloadIsValid(payload) {
  return (
    ["page", "group", "type", "name", "value"].findIndex(
      (key) => typeof payload[key] === "undefined"
    ) === -1
  );
}

// returns false if property doesn't exist in vuex store's state
function pathValid(state, payload) {
  return !(
    typeof state?.[payload.page]?.[payload.group]?.[payload.type]?.[
      payload.name
    ] === "undefined"
  );
}

// temp commented out stateIsValid
const mutations = {
  setStoreVar(state, payload) {
    if (!storeVarPayloadIsValid(payload)) {
      throw new Error("Payload invalid");
    }
    const { page, group, type, name, value } = payload;
    if (!pathValid(state, payload)) {
      throw new Error(`Path ${page} ${group} ${type} ${name} cannot be found.`);
    }
    state[page][group][type][name] = recursivelyEnhanceMedia(value);
  },
  setStylingData(state, payload) {
    // save styling data for pages
    const pages = [
      "Home",
      "Categories",
      "SubCategories",
      "Category",
      "Person",
      "Settings",
    ];

    for (const page in pages) {
      for (const type in state[pages[page]].styling) {
        for (const varName in state[pages[page]].styling[type]) {
          state[pages[page]].styling[type][varName] = recursivelyEnhanceMedia(
            payload[varName]
          );
        }
      }
    }
  },
  setPageData(state, payload) {
    // save page data
    const { pageName } = payload;
    for (const type in state[pageName].page) {
      for (const varName in state[pageName].page[type]) {
        state[pageName].page[type][varName] = recursivelyEnhanceMedia(
          payload.data[varName]
        );
      }
    }
  },
  setAuth(state, isAuth) {
    state.isAuth = isAuth;
  },
  setIsAdmin(state, isAdmin) {
    state.isAdmin = isAdmin;
  },
  setIsInternal(state, isInternal) {
    state.isInternal = isInternal;
  },
  setHasSignedAgreements(state, hasSignedAgreements) {
    state.hasSignedAgreements = hasSignedAgreements;
  },
  setSiteIds(state, siteIds) {
    state.siteIds = siteIds;
  },
  setClientID(state, payload) {
    state.clientID = payload;
  },
  setDefaultSiteId(state, defaultSiteId) {
    state.defaultSiteId = defaultSiteId;
  },
  setSelectedHomeButton(state, payload) {
    state.selectedHomeButton = payload;
  },
  setIsAnnouncementsEditorOpen(state, payload) {
    state.isAnnouncementsEditorOpen = payload;
  },
  setTouchScreen(state, payload) {
    state.touchScreen = payload;
  },
  setAccessible(state, payload) {
    state.accessible = payload;
  },
  setNoTouch(state, payload) {
    state.noTouch = payload;
  },
  setAppInitialized(state, payload) {
    state.appInitialized = payload;
  },
  setCategoriesURLQueries(state, payload) {
    state.categoriesURLQueries = payload;
  },
  setStyleID(state, payload) {
    state.styleID = payload;
  },
  setUserEmail(state, payload) {
    state.userEmail = payload;
  },
  setIsSaving(state, payload) {
    state.isSaving = payload;
  },
  setIsMobileDrawerOpen(state, payload) {
    state.isMobileDrawerOpen = payload;
  },

  // authentication
  setToken(state, payload) {
    state.accessToken = payload;
  },
  setUserID(state, payload) {
    state.userID = payload;
  },
  setShowLogin(state, payload) {
    state.showLogin = payload;
  },
  setSiteNavigatorVar(state, payload) {
    const { key, value } = payload;
    state.SiteNavigator[key] = value;
  },
  setSettingsVar(state, payload) {
    const { key, value } = payload;
    state.Settings[key] = value;
  },
  setServerErrorMessage(state, payload) {
    // Provide default values in case payload is undefined
    const { message = "", returnToPreviousPage = false } = payload;

    state.serverErrorMessage.message = message;
    state.serverErrorMessage.returnToPreviousPage = returnToPreviousPage;
  },
  setShowCMS(state, payload) {
    state.showCMS = payload;
  },
  setSiteBuilderFormVar(state, payload) {
    const { key, value } = payload;
    state.SiteBuilderForm[key] = value;
  },
  setIsSiteBuilderFormOpen(state, payload) {
    state.isSiteBuilderFormOpen = payload;
  },
  patchAllMedia(state, { updatedDoc, id }) {
    [
      "Settings",
      "Home",
      "Category",
      "SubCategories",
      "Categories",
      "Person",
    ].forEach((page) => {
      if (typeof state[page] === "object") {
        Object.keys(state[page]).forEach((group) => {
          if (typeof state[page][group] === "object") {
            Object.keys(state[page][group]).forEach((type) => {
              if (typeof state[page][group][type] === "object") {
                Object.keys(state[page][group][type]).forEach((name) => {
                  if (typeof state[page][group][type][name] === "object") {
                    const value = state[page][group][type][name];
                    if (Array.isArray(value)) {
                      const item = value.find((i) => i._id === id);
                      if (!item) {
                        return;
                      }
                      const newItem = { ...item, ...updatedDoc };
                      const newItems = value.map((i) => {
                        if (i._id === id) {
                          return newItem;
                        }
                        return i;
                      });
                      state[page][group][type][name] = [...newItems];
                    }
                  }
                });
              }
            });
          }
        });
      }
    });
  },
  setOrganizationName(state, payload) {
    state.organizationName = payload;
  },
  setIsActivated(state, payload) {
    state.isActivated = payload;
  },
  setSearchQuery(state, payload) {
    state.searchQuery = payload;
  },
  setSearchResults(state, payload) {
    state.searchResults = payload;
  },
  setRoutePending(state, payload) {
    state.isRoutePending = payload;
  },
  setCsDetails(state, payload) {
    state.csDetails = payload;
  },
};

export default mutations;
